export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS';
export const LOAD_TAGS_SUCCESS = 'LOAD_TAGS_SUCCESS';